import styled from "styled-components";

export const EventDurationStepPlaceholder = styled.div`
  display: flex;
`;
export const EventDurationStepIncrement = styled.div`
display: inline:block;
margin: auto
`;
